var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('Homepage'),_c('About'),_c('Work'),_c('Projects'),_c('contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }